"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var TableColumn_1 = require("./TableColumn");
var Table = function (_a) {
    var ariaDescribedBy = _a.ariaDescribedBy, ariaLabel = _a.ariaLabel, ariaRowCount = _a.ariaRowCount, id = _a.id, children = _a.children;
    var childrenArray = Array.isArray(children) ? children : [children];
    if (childrenArray.length === 0) {
        return null;
    }
    var attributes = {
        className: 'table',
        id: id,
        role: 'table',
    };
    var columnsWidthsString = '';
    var alignmentsArray = [];
    var tableColumns = childrenArray[0];
    var columnsCount = 0;
    columnsCount = tableColumns.props.children.length;
    var columnsArray = Array.isArray(tableColumns.props.children) ?
        tableColumns.props.children : [tableColumns.props.children];
    var widthTypeProp = 'widthType';
    var widthValueProp = 'widthValue';
    var alignmentProp = 'alignment';
    columnsArray.forEach(function (column) {
        /* tslint:disable:no-string-literal */
        var widthType = column.props[widthTypeProp];
        var widthValue = column.props[widthValueProp];
        alignmentsArray.push(column.props[alignmentProp]);
        /* tslint:disable:no-string-literal */
        if (widthType === TableColumn_1.WidthType.AUTO) {
            columnsWidthsString += widthType.toString() + " ";
        }
        else {
            columnsWidthsString += widthValue ? "" + widthValue + widthType.toString() + " " : TableColumn_1.WidthType.AUTO + " ";
        }
    });
    attributes['aria-colcount'] = columnsCount;
    attributes.style = { gridTemplateColumns: columnsWidthsString };
    if (ariaDescribedBy) {
        attributes['aria-describedby'] = ariaDescribedBy;
    }
    if (ariaLabel) {
        attributes['aria-label'] = ariaLabel;
    }
    if (ariaRowCount) {
        attributes['aria-rowcount'] = ariaRowCount;
    }
    return (React.createElement("div", __assign({}, attributes), React.Children.map(childrenArray, function (child, index) {
        return React.cloneElement(child, { columnsAlignments: alignmentsArray, ariaRowIndex: index + 1 });
    })));
};
exports.Table = Table;
exports.Table.propTypes = {
    ariaDescribedBy: PropTypes.string,
    ariaLabel: PropTypes.string,
    ariaRowCount: PropTypes.number,
    id: PropTypes.string.isRequired,
};
